import Badge from "@edaz/edazkit/Badge";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import type ChargeType from "entities/chargeType";
import { emptyValue } from "utils/emptyValue";
import { formatDate } from "utils/localizations";
import ChargeTypesViewModel from "viewModels/timeCharges/chargeTypes/chargeTypesViewModel";
import type { ListColumnDefinition } from "../../common/list";
import ListView from "../../common/list";

const ChargeTypesView: ViewComponent<ChargeTypesViewModel> = observer(({ vm }) => {
  const columns: ListColumnDefinition<ChargeType>[] = [
    {
      title: vm.translateAttribute("name"),
      property: "name",
    },
    {
      title: vm.translateAttribute("chargeCode"),
      property: "chargeCode",
    },
    {
      title: vm.translateAttribute("validFor"),
      property: "validFor",
      valueFormatter: props => vm.translateValidFor(props.value),
    },
    {
      title: vm.translateAttribute("notifyDaysBefore"),
      property: "notifyDaysBefore",
      numberProperty: true,
      valueFormatter: props => props.value ?? emptyValue,
    },
    {
      title: vm.translateAttribute("validSince"),
      property: "validSince",
      valueFormatter: props => formatDate(props.value),
    },
    {
      title: vm.translateAttribute("validUntil"),
      property: "validUntil",
      valueFormatter: props => formatDate(props.value),
    },
    {
      title: vm.translateAttribute("isValid"),
      property: "isValid",
      valueFormatter: props => {
        if (props.value) {
          return (
            <Badge variant="success" className="p-2">
              {vm.translateGeneral("active")}
            </Badge>
          );
        }

        return (
          <Badge variant="danger" className="p-2">
            {vm.translateGeneral("inactive")}
          </Badge>
        );
      },
    },
  ];

  return <ListView vm={vm} columns={columns} />;
});

registerView(ChargeTypesView, ChargeTypesViewModel);
